export default {
  title: "创建组织以开始使用",
  description:
    "设置组织后，你可以在统一空间中管理广告活动、跟踪效果并与团队协作。",
  fields: {
    logo: "Logo（选填）",
    name: "名称",
  },
  buttons: {
    upload: "上传",
    create: "创建组织",
  },
  logoRecommendation: "建议使用 1:1 尺寸，文件不超过 10MB",

  // 错误消息
  errors: {
    failedToUploadLogo: "Logo 上传失败，请稍后重试。",
    fileSizeExceeded: "文件大小不能超过 10MB！",
    failedToCreateOrganization: "创建组织失败，请稍后重试。",
  },
  
  // 表单验证消息
  validation: {
    organizationNameRequired: "请输入组织名称",
    nameTooLong: "名称长度不能超过 256 个字符。",
  },
  
  // 表单占位符
  placeholders: {
    organizationName: "组织名称",
  },
};
